// extracted by css-extract-rspack-plugin
var _1 = "bg";
var _2 = "bl";
var _3 = "bh";
var _4 = "bj";
var _5 = "bk";
var _6 = "bi";
var _7 = "bf";
export { _1 as "eventsPanel", _2 as "locationContainer", _3 as "locationInfoComponent", _4 as "mapComponent", _5 as "shoppingMallsListsMapComponent", _6 as "shoppingMallsMapPanel", _7 as "shoppingMallsTabComponent" }
